import { Deserializable } from '../deserializable';
import { UserIdentifiers } from '../users/user-identifiers';

export class DocumentRequest implements Deserializable {
  $type: string;
  userIdentifiers: UserIdentifiers;
  documentType: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
